import TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import { LazyImport, LazyModule } from 'owa-bundling';
import './mutators/initializeGuidsForSearchStoreMutator';
import './mutators/setSearchTextMutator';
import './mutators/setStaticFolderScopeIdMutator';
import './mutators/setIsSearchHistoryDirtyMutator';
import './mutators/shallowClearSearchStoreMutator';
import './orchestrators/startSearchSessionOrchestrator';
import './orchestrators/endSearchSessionOrchestrator';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "SearchActions" */ './lazyIndex')
);

export const lazylogSearchDone = new LazyImport(lazyModule, m => m.logSearchDone);
export const lazylogSessionEnd = new LazyImport(lazyModule, m => m.logSessionEnd);

export { TableView };

export { getStore } from './store/Store';

export { default as clearSearchBox } from './mutators/clearSearchBox';
export { default as setSuggestionPill } from './mutators/setSuggestionPill';
export { default as resetSearchState } from './mutators/resetSearchState';

export { default as endSearchSession } from './actions/endSearchSession';
export { default as startSearchSession } from './actions/startSearchSession';
export { default as setSearchText } from './actions/setSearchText';
export { Suggestion } from './store/schema/SuggestionSet';
